import React from "react";
import { useLike } from "../../hooks/useLike";
import { icAsset } from "../image/image-src";

const LikeBtn: React.FC<{
  id?: number;
}> = ({ id }) => {
  const { handleLike, like } = useLike(id);
  return (
    <button
      disabled={!id}
      onClick={handleLike}
      className="h-[2.75rem] w-[2.75rem] content-center rounded-full border border-[#DEDEDE] text-center"
    >
      <img
        className="mx-auto h-4 w-4"
        src={icAsset(`../../assets/icons/like${like ? "d" : ""}.svg`)}
        alt="like"
      />
    </button>
  );
};

export default LikeBtn;
